export async function sendResendEmail(apiKey, fromEmail, { to, subject, html }) {
  if (!apiKey || !fromEmail || !to) return { ok: false, err: "Resend not configured" };
  try {
    const toArr = Array.isArray(to) ? to : to.split(",").map(s => s.trim()).filter(Boolean);
    const res = await fetch("https://api.resend.com/emails", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${apiKey}` },
      body: JSON.stringify({ from: fromEmail, to: toArr, subject, html })
    });
    return res.ok ? { ok: true } : { ok: false, err: await res.text() };
  } catch (e) {
    const isCors = e instanceof TypeError && (e.message.includes("Failed to fetch") || e.message.includes("NetworkError") || e.message.includes("CORS"));
    if (isCors) return { ok: true, corsWarning: true };
    return { ok: false, err: e.message };
  }
}

export function buildRewardRequestEmail({ child, reward, approveUrl, declineUrl }) {
  return `<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;padding:24px;color:#1e293b">
  <div style="font-size:22px;font-weight:800;margin-bottom:6px">🎁 Reward Request</div>
  <div style="font-size:16px;color:#64748b;margin-bottom:24px">${child.avatar} ${child.name} has requested a reward</div>
  <div style="background:#f1f5f9;border-radius:12px;padding:20px;margin-bottom:24px">
    <div style="font-size:36px;margin-bottom:8px">${reward.emoji || "🎁"}</div>
    <div style="font-weight:800;font-size:20px;color:#1e293b">${reward.name}</div>
    <div style="color:#d97706;font-weight:700;margin-top:6px;font-size:16px">⭐ ${reward.cost} points</div>
    ${reward.custom ? `<div style="margin-top:8px;font-size:14px;color:#7c3aed;font-weight:600">(custom request)</div>` : ""}
  </div>
  <div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:28px">
    <a href="${approveUrl}" style="display:inline-block;padding:14px 28px;background:#16a34a;color:#ffffff;font-weight:800;font-size:16px;border-radius:12px;text-decoration:none">✅ Approve</a>
    <a href="${declineUrl}" style="display:inline-block;padding:14px 28px;background:#dc2626;color:#ffffff;font-weight:800;font-size:16px;border-radius:12px;text-decoration:none">❌ Decline</a>
  </div>
  <div style="font-size:13px;color:#94a3b8">Tap Approve or Decline above — no need to open the app.</div>
  <div style="margin-top:24px;padding-top:16px;border-top:1px solid #e5e7eb;font-size:13px;color:#94a3b8">Sent automatically by SpellWise Kids</div>
</div>`;
}

export function buildRewardConfirmEmail({ child, reward }) {
  return `<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;padding:24px;color:#1e293b">
  <div style="font-size:22px;font-weight:800;margin-bottom:6px">⏳ Request Sent!</div>
  <div style="font-size:16px;color:#64748b;margin-bottom:24px">Hi ${child.name}! Your reward request has been sent to your parents.</div>
  <div style="background:#fef3c7;border-radius:12px;padding:20px;margin-bottom:20px">
    <div style="font-size:36px;margin-bottom:8px">${reward.emoji || "🎁"}</div>
    <div style="font-weight:800;font-size:20px;color:#1e293b">${reward.name}</div>
    <div style="color:#d97706;font-weight:700;margin-top:6px;font-size:16px">⭐ ${reward.cost} points</div>
  </div>
  <div style="font-size:15px;color:#64748b">We'll let you know once your parents have reviewed it. Keep up the great work! 🌟</div>
  <div style="margin-top:32px;padding-top:16px;border-top:1px solid #e5e7eb;font-size:13px;color:#94a3b8">Sent automatically by SpellWise Kids</div>
</div>`;
}

export function buildRewardOutcomeEmail({ child, reward, approved, parentNote }) {
  return `<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;padding:24px;color:#1e293b">
  <div style="font-size:28px;margin-bottom:8px">${approved ? "🎉" : "😔"}</div>
  <div style="font-size:22px;font-weight:800;margin-bottom:6px">${approved ? "Reward Approved!" : "Reward Not Approved"}</div>
  <div style="font-size:16px;color:#64748b;margin-bottom:24px">Hi ${child.name}! Here's the update on your reward request.</div>
  <div style="background:${approved ? "#dcfce7" : "#fee2e2"};border-radius:12px;padding:20px;margin-bottom:20px">
    <div style="font-size:32px;margin-bottom:8px">${reward.emoji || "🎁"}</div>
    <div style="font-weight:800;font-size:18px;color:#1e293b">${reward.name}</div>
    <div style="margin-top:8px;font-size:15px;font-weight:700;color:${approved ? "#16a34a" : "#dc2626"}">${approved ? "✅ Approved" : "❌ Not approved this time"}</div>
  </div>
  ${parentNote ? `<div style="background:#f1f5f9;border-radius:10px;padding:14px;margin-bottom:20px;font-size:15px;color:#1e293b"><strong>Note from your parents:</strong><br/>${parentNote}</div>` : ""}
  <div style="font-size:15px;color:#64748b">${approved ? "Enjoy your reward! You earned it. Keep up the amazing work! 🌟" : "Don't give up — keep earning points and try again! 💪"}</div>
  <div style="margin-top:32px;padding-top:16px;border-top:1px solid #e5e7eb;font-size:13px;color:#94a3b8">Sent automatically by SpellWise Kids</div>
</div>`;
}
